<template>
  <div class="menu-page">
    <div>
      <dashboard-nav></dashboard-nav>
      <div class="d-flex bodyWrapper">
        <div class="nav-view">
          <main-nav></main-nav>
        </div>

        <!-- VIEW START -->
        <div class="main-view">
          <!-- <breadcrumb></breadcrumb> -->

          <v-form v-if="isOrderDone == true" ref="placeFinalOrder">
            <v-row>
              <v-col cols="8">
                <div
                  class="intro-wrapper d-flex justify-space-between align-center"
                >
                  <div class="main-x-spacing">
                    <h2>{{ title }}</h2>
                  </div>

                  <div class="pr-3 d-flex">
                    <v-select
                      v-model="filterByBrand"
                      placeholder="Select Menu By Brand"
                      :items="entepriseBrands"
                      item-text="brandName"
                      item-value="id"
                      :menu-props="{ offsetY: true }"
                      class="f9-bg mb-3"
                      dense
                      hide-details
                      chips
                      flat
                      solo
                      :rules="[rules.required]"
                    ></v-select>

                    <span class="mx-2"></span>

                    <v-select
                      v-if="userType > 8"
                      v-model="menuLocationByAdmin"
                      placeholder="Select Order Location"
                      :items="enterpriseLocations"
                      item-text="locationName"
                      item-value="id"
                      :menu-props="{ offsetY: true }"
                      class="f9-bg mb-3"
                      dense
                      hide-details
                      chips
                      flat
                      solo
                    ></v-select>
                  </div>
                </div>
              </v-col>
              <v-col cols="4">
                <div
                  class="white d-flex justify-space-between align-center pa-4"
                >
                  <div class="brandImage"></div>

                  <v-select
                    v-model="paymentType"
                    :items="['delivery', 'pickup', 'drive-through']"
                    outlined
                    dense
                    class="txtCap"
                    placeholder="Payment Type"
                    data-vv-name="country"
                    hide-details
                    :rules="[rules.required]"
                  ></v-select>
                </div>
              </v-col>
            </v-row>
          </v-form>

          <v-row v-else>
            <v-col cols="12">
              <div class="intro-wrapper py-3">
                <div class="main-x-spacing">
                  <h2>{{ title }}</h2>
                </div>
              </div>
            </v-col>
          </v-row>
          <!-- main view -->

          <!-- START -->
          <div class="main-body-content main-x-spacing">
            <v-row v-if="!isOrderDone">
              <v-col cols="9">
                <!--  -->

                <!-- Find Customer -->
                <v-row v-if="orderStage == 'findCustomer'">
                  <v-col cols="12" class="pb-0 relative">
                    <!-- <pre>{{ filteredSearchResult }}</pre> -->
                    <!-- {{ filteredSearchResult }} -->
                    <v-text-field
                      v-model="searchQuery"
                      @focusout="closeSearchModal()"
                      prepend-inner-icon="search"
                      placeholder="Type phone number to start searching..."
                      autocomplete="off"
                      outlined
                      class="toWhite searchQuery"
                      flat
                      hide-details
                      single-line
                      solo
                    ></v-text-field>

                    <!-- Search Result Panel -->
                    <div v-if="showResultPanel" class="resultPanelWrapper">
                      <div class="resultPanel shadow-me-light border-me-light">
                        <div class="f9-bg border-me-light py-4">
                          <!--  -->

                          <!-- If Customer was found -->
                          <div v-if="foundCustomer" class="">
                            <div
                              v-for="(customer, index) in filteredSearchResult"
                              :key="index"
                              class="d-flex justify-space-between pa-3 mb-2 border-me-light eachResult"
                              style="background: #fff"
                            >
                              <span
                                @click="
                                  nextStage('foundCustomer');
                                  customerResult = customer;
                                "
                              >
                                {{ customer.fullName }} ({{
                                  customer.phone || " Missing Number "
                                }})
                              </span>
                            </div>
                          </div>

                          <!-- If no Customer was found -->
                          <div
                            v-if="!foundCustomer && searchQuery.length > 1"
                            class="d-flex justify-space-between pa-4"
                          >
                            <div>No result found</div>
                            <div>
                              <span class="caption">
                                Add
                                <b>
                                  <em>{{ searchQuery }}</em>
                                </b>
                                as a new customer?
                              </span>
                              <v-icon
                                class="addCustomer-icon"
                                @click="appendMissingCustomer"
                              >
                                add_box
                              </v-icon>
                            </div>
                          </div>
                        </div>
                        <div class="text-center">
                          <v-btn
                            icon
                            depressed
                            :loading="searchLoading"
                          ></v-btn>
                        </div>
                      </div>
                    </div>
                  </v-col>
                </v-row>

                <!-- Found Customer so, -->
                <!-- Populate Found Customer -->
                <v-row v-if="orderStage === 'foundCustomer'">
                  <!-- customerResult: {{ customerResult }} -->
                  <v-col cols="12">
                    <div class="border-me-light f9-bg pa-8">
                      <div class="d-flex">
                        <img
                          class="round-avatar"
                          :src="
                            customerResult.image ||
                            require('@/assets/avatar.png')
                          "
                        />
                        <div class="ml-7">
                          <h2>
                            {{ customerResult.fullName }}
                          </h2>
                          <div>Phone: {{ customerResult.phone }}</div>
                        </div>
                      </div>

                      <div class="mt-4">Delivery Address</div>
                      <div
                        class="pa-4 border-me-light relative"
                        style="background: #fff"
                      >
                        <div>
                          {{
                            customerResult.buildingNumber +
                            " " +
                            customerResult.streetName +
                            ","
                          }}
                        </div>
                        <div>
                          {{ customerResult.nearestLandmark + "," }}
                        </div>
                        <div>
                          {{ customerResult.deliveryArea + "." }}
                        </div>
                        <v-icon
                          color="black"
                          class="editCustomerBtn"
                          @click="
                            addCustomerData = customerResult;
                            editCustomerMode = true;
                          "
                        >
                          history_edu
                        </v-icon>
                      </div>
                    </div>
                    <div class="text-right">
                      <v-btn
                        :ripple="false"
                        depressed
                        color="#048441"
                        width="30%"
                        height="80px"
                        x-large
                        class="gen-button white--text mt-2"
                        @click="
                          isOrderDone = true;
                          searchQuery = '';
                        "
                      >
                        <span style="font-size: 1.5em">Place New Order</span>
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="3" class="col-2-side-tab col-2-side-tab-right">
                <h3 class="mb-4 yellow-border-left">
                  <span class="px-8">Add New Customer</span>
                </h3>
                <div class="px-8">
                  <v-form ref="customerForm">
                    <v-text-field
                      v-model="addCustomerData.phone"
                      placeholder="Phone Number"
                      class="toWhite mb-3"
                      outlined
                      dense
                      flat
                      hide-details
                      solo
                      :rules="[rules.required, rules.numberMax15]"
                    ></v-text-field>
                    <v-text-field
                      v-model="addCustomerData.fullName"
                      placeholder="Full Name"
                      class="toWhite mb-3"
                      outlined
                      dense
                      flat
                      hide-details
                      solo
                      :rules="[rules.required]"
                    ></v-text-field>
                    <v-select
                      v-model="addCustomerData.locationId"
                      placeholder="Location/Branch"
                      :items="enterpriseLocations"
                      item-text="locationName"
                      item-value="id"
                      :menu-props="{ offsetY: true }"
                      class="toWhite mb-3"
                      outlined
                      dense
                      hide-details
                      chips
                      flat
                      solo
                      :rules="[rules.required]"
                    ></v-select>
                    <v-text-field
                      v-model="addCustomerData.buildingNumber"
                      placeholder="Building Number"
                      class="toWhite mb-3"
                      outlined
                      dense
                      flat
                      hide-details
                      solo
                      :rules="[rules.required, rules.number]"
                    ></v-text-field>
                    <v-text-field
                      v-model="addCustomerData.streetName"
                      placeholder="Street Name"
                      class="toWhite mb-3"
                      outlined
                      dense
                      flat
                      hide-details
                      solo
                      :rules="[rules.required]"
                    ></v-text-field>
                    <v-text-field
                      v-model="addCustomerData.city"
                      placeholder="City"
                      class="toWhite mb-3"
                      outlined
                      dense
                      flat
                      hide-details
                      solo
                      :rules="[rules.required]"
                    ></v-text-field>
                    <v-text-field
                      v-model="addCustomerData.nearestLandmark"
                      placeholder="Nearest Landmark"
                      class="toWhite mb-3"
                      outlined
                      dense
                      flat
                      hide-details
                      solo
                      :rules="[rules.required]"
                    ></v-text-field>
                    <v-text-field
                      v-model="addCustomerData.deliveryArea"
                      placeholder="Type Delivery Area Name"
                      class="toWhite mb-3"
                      outlined
                      dense
                      flat
                      hide-details
                      solo
                      :rules="[rules.required]"
                    ></v-text-field>
                    <div class="text-center mb-2">
                      <v-btn
                        v-if="!editCustomerMode"
                        :ripple="false"
                        depressed
                        color="#048441"
                        width="100%"
                        class="gen-button white--text"
                        :loading="addCustomerLoader"
                        @click="addCustomer"
                      >
                        Add Customer
                      </v-btn>
                      <v-btn
                        v-else
                        :ripple="false"
                        depressed
                        color="#048441"
                        width="100%"
                        class="gen-button white--text"
                        :loading="addCustomerLoader"
                        @click="editCustomer"
                      >
                        Save Customer
                      </v-btn>
                    </div>

                    <div class="text-center mb-2">
                      <v-btn
                        :ripple="false"
                        depressed
                        color="#E2001F"
                        width="100%"
                        class="gen-button white--text"
                        @click="resetAddCustomerData()"
                      >
                        Cancel
                      </v-btn>
                    </div>
                  </v-form>
                </div>
              </v-col>
            </v-row>

            <!-- Process Order Screen -->
            <v-row v-if="isOrderDone">
              <v-col cols="8" class="px-8">
                <div class="orderMenuCat">
                  <v-tabs show-arrows icons-and-text class="mb-3">
                    <v-tabs-slider color="teal lighten-3"></v-tabs-slider>

                    <v-tab
                      v-for="(cat, index) in categories"
                      :key="index"
                      :href="'#tab-' + index"
                      class="orderMenuCatTab primary mx-1"
                    >
                      <v-btn
                        :ripple="false"
                        depressed
                        x-large
                        text
                        class="py-4 no-Btn-bg"
                        @click="filterDataByCat = cat.id"
                      >
                        <span class="text-capitalize">{{ cat.name }}</span>
                      </v-btn>
                    </v-tab>
                  </v-tabs>
                </div>

                <!-- <pre>{{ orderTable }}</pre> -->

                <div>
                  <v-text-field
                    v-model="searchQuery"
                    prepend-inner-icon="search"
                    placeholder="Search Menu Item"
                    outlined
                    class="toWhite"
                    flat
                    hide-details
                    single-line
                    solo
                  ></v-text-field>

                  <v-text-field
                    v-if="menuDataReady == null"
                    style="width: 40%; margin: 0 auto"
                    color="success"
                    loading
                    disabled
                  ></v-text-field>

                  <!-- Server menu Response came back successfull -->
                  <div v-if="menuDataReady">
                    <v-row
                      class="menubyBrands-wrapper"
                      v-if="orderFilteredSearchResult.length > 1"
                    >
                      <v-col
                        cols="3"
                        v-for="(menu, index) in orderFilteredSearchResult"
                        :key="index"
                        class="pa-1"
                      >
                        <div
                          class="menubyBrands"
                          @click="addToOrderTable(menu)"
                        >
                          <div class="">{{ menu.name }}</div>

                          <!-- For menu with more than 1 variation -->
                          <div v-if="menu.menuvariations.length > 1">
                            <b><em>Variant Prices</em></b>
                          </div>

                          <div v-if="menu.menuvariations.length == 1">
                            <b>
                              <span v-if="menu.currency">
                                {{ menu.currency }}
                              </span>
                              <span>{{ menu.menuvariations[0].price }}</span>
                            </b>
                          </div>
                        </div>
                      </v-col>
                    </v-row>

                    <!-- No search result -->
                    <div v-else class="menubyBrands-wrapper">
                      <p class="f9-bg text-center pa-5">No Menu Result</p>
                    </div>
                  </div>

                  <!-- Server returned error on menu fetch -->
                  <div
                    v-if="menuDataReady == false"
                    class="responseReady errorReady mt-10"
                  >
                    Oops! Error fetching Menu. Please try again later.
                  </div>
                </div>
              </v-col>

              <!-- Process Order/Table -->
              <v-col cols="4" class="processOrder pa-0">
                <!-- Customer Info -->
                <div
                  class="customer-info-wrapper pa-4 d-flex justify-space-between"
                >
                  <div>
                    <div>
                      <v-icon>person</v-icon>
                      <span>{{ customerResult.fullName }}</span>
                    </div>
                    <div>
                      <v-icon>house</v-icon>
                      <span>
                        {{
                          customerResult.buildingNumber +
                          " " +
                          customerResult.streetName +
                          ","
                        }}
                      </span>
                      <span>
                        {{ customerResult.nearestLandmark + "," }}
                      </span>
                      <span>
                        {{ customerResult.deliveryArea + "." }}
                      </span>
                    </div>
                  </div>
                  <div>
                    <v-icon color="red">remove_circle_outline</v-icon>
                  </div>
                </div>

                <!-- Menu Selection Table -->
                <div>
                  <!-- No Menu Selected -->
                  <div v-if="orderTable.length < 1" class="py-12">
                    <div class="text-center">
                      <em>
                        Order is empty. Please make a selection to your left
                      </em>
                    </div>
                  </div>

                  <!-- Calculator -->
                  <div v-else class="orderCalc">
                    <table class="pa-4">
                      <colgroup>
                        <col span="1" style="width: 40%" />
                        <col span="1" style="width: 30%" />
                        <col span="1" style="width: 20%" />
                      </colgroup>

                      <thead class="white">
                        <tr>
                          <th>Item</th>
                          <!-- <th></th> -->
                          <th>Qty</th>
                          <th>Total({{ enterpriseCurrency.symbol }})</th>
                          <th></th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr
                          v-for="(order, index) in orderTable"
                          :key="index"
                          class="tr"
                        >
                          <td>
                            <!-- <pre>{{ orderTable }}</pre> -->
                            <pre>{{ orderTable.resModifiers }}</pre>
                            {{ order.name }}
                            <div>
                              {{ order.onlyDefault ? "Default" : "" }}
                            </div>
                            <v-select
                              v-if="!order.onlyDefault"
                              @change="updateUnitPriceVar($event, index)"
                              placeholder="Variation"
                              :items="order.menuvariations"
                              item-text="name"
                              return-object
                              :menu-props="{ offsetY: true }"
                              class="mb-2"
                              height="10px"
                              outlined
                              dense
                              hide-details
                            ></v-select>
                            <!-- <pre>{{ order.meta.modifiers }}</pre> -->
                            <div v-if="!order.getSelectedTotal">
                              <v-btn
                                v-if="
                                  order.meta.modifiers &&
                                  order.meta.modifiers.length > 0
                                "
                                :ripple="false"
                                depressed
                                color="#048441"
                                class="gen-button white--text mt-2"
                                :disabled="order.unitPrice < 1"
                                @click="selectOwnModifier(order, index)"
                              >
                                <span>Select Modifiers</span>
                              </v-btn>
                            </div>
                            <div v-else>
                              <v-btn
                                v-if="order.meta.modifiers"
                                :ripple="false"
                                depressed
                                color="red"
                                class="gen-button white--text mt-2"
                                :disabled="order.unitPrice < 1"
                                @click="resetSelectedMod(index)"
                              >
                                <span>Reset Modifiers</span>
                              </v-btn>
                            </div>
                            <div>
                              <div
                                v-for="(mod, index) in order.getSelectedTotal"
                                :key="index"
                              >
                                <v-icon size="10">stop_circle</v-icon>
                                <span class="text-capitalize">
                                  {{ mod.name }}
                                </span>
                                <b>{{ mod.sumPrice }}</b>
                              </div>
                            </div>
                          </td>
                          <!-- <td></td> -->
                          <td class="pt-0">
                            <div class="d-flex justify-center align-center">
                              <v-btn
                                depressed
                                color="#5FA45F"
                                class="white--text"
                                x-small
                                height="27px"
                                :disabled="order.unitPrice < 1"
                                @click="decrementOrder(index)"
                              >
                                <v-icon size="15">remove</v-icon>
                              </v-btn>

                              <span class="px-1">{{ order.quantity }}</span>

                              <v-btn
                                depressed
                                color="#5FA45F"
                                class="white--text"
                                x-small
                                height="27px"
                                :disabled="order.unitPrice < 1"
                                @click="incrementOrder(index)"
                              >
                                <v-icon size="15">add</v-icon>
                              </v-btn>
                            </div>
                          </td>
                          <td>
                            {{
                              order.unitPrice > -1
                                ? order.unitPrice
                                : "Choose variation"
                            }}
                            <!-- {{
                            order.price >
                            parseInt(order.price) * parseInt(order.quantity)
                              ? order.price
                              : parseInt(order.price) *
                                parseInt(order.quantity)
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          }} -->
                          </td>
                          <td>
                            <v-btn depressed icon @click="removeOrder(index)">
                              <v-icon class="outlined">cancel</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <!-- Tax, Surcharge, Discount and Coupon -->
                    <v-row>
                      <v-spacer></v-spacer>
                      <v-col cols="6">
                        <!-- <pre>
                          {{ calcSurcharge }}
                        </pre> -->

                        <!-- Tax -->
                        <v-select
                          v-model="tax"
                          :disabled="calcAmountToPay < 1"
                          :items="allTaxes"
                          item-text="name"
                          return-object
                          :menu-props="{ offsetY: true }"
                          outlined
                          dense
                          class="txtCap mb-2"
                          multiple
                          placeholder="Select Tax"
                          hide-details
                        ></v-select>

                        <!-- Surcharge -->
                        <v-select
                          v-model="surcharge"
                          :disabled="calcAmountToPay < 1"
                          :items="allSurcharges"
                          item-text="name"
                          return-object
                          :menu-props="{ offsetY: true }"
                          outlined
                          dense
                          class="txtCap mb-2"
                          multiple
                          placeholder="Select Surcharge"
                          hide-details
                        ></v-select>

                        <!-- Discount Type -->
                        <v-select
                          v-model="discountType"
                          :disabled="calcAmountToPay < 1"
                          :items="discountTypeOptions"
                          item-text="name"
                          item-value="value"
                          :menu-props="{ offsetY: true }"
                          outlined
                          dense
                          class="txtCap mb-2"
                          placeholder="Select Dicount Type"
                          hide-details
                        ></v-select>

                        <v-text-field
                          v-if="discountType == 'coupon'"
                          v-model="couponCode"
                          @click:append="
                            couponValue > 1 ? resetCoupon() : verifyCoupon()
                          "
                          :append-icon="
                            mustResetCoupon || couponValue > 1
                              ? 'do_not_disturb_on'
                              : 'arrow_right_alt'
                          "
                          placeholder="Enter Coupon"
                          autocomplete="off"
                          outlined
                          class="toWhite"
                          flat
                          dense
                          hide-details
                          single-line
                          solo
                        ></v-text-field>
                        <div
                          v-if="couponValue && calcAmountToPay > 0"
                          class="responseReady caption py-1 mt-2"
                        >
                          <em>Coupon applied</em>
                        </div>
                        <div
                          v-else-if="couponValue && calcAmountToPay < 0"
                          class="responseReady errorReady caption py-1 mt-2"
                        >
                          <em>Coupon should not be applied</em>
                        </div>
                        <div
                          v-if="couponResponse"
                          class="responseReady caption py-1 mt-2"
                        >
                          <em>
                            {{ couponResponse }}
                          </em>
                        </div>

                        <v-select
                          v-model="discount"
                          v-if="discountType == 'discount'"
                          :items="allDiscounts"
                          item-text="name"
                          return-object
                          :menu-props="{ offsetY: true }"
                          outlined
                          dense
                          class="txtCap mb-2"
                          placeholder="Select Discount"
                          hide-details
                        ></v-select>
                      </v-col>
                    </v-row>

                    <!-- Total -->
                    <!-- calc discount: {{ discount }} -->
                    <div class="mt-10">
                      <div class="text-right">
                        <div>
                          Sub Total <span class="ml-2">{{ subTotal }}</span>
                        </div>
                        <div>
                          Applicable Discount
                          <span class="ml-2">{{ calcDiscountedValue }}</span>
                        </div>
                        <div>
                          Tax
                          <span class="ml-2">{{ calcTax }}</span>
                        </div>

                        <div>
                          Amount to Pay
                          <span class="ml-2">{{ calcAmountToPay }}</span>
                        </div>
                      </div>

                      <div
                        v-if="ruleMsg"
                        class="responseReady errorReady caption py-1"
                      >
                        {{ ruleMsg }}
                      </div>

                      <!-- invalidateAmountToPay: {{ invalidateAmountToPay }} -->

                      <div class="d-flex">
                        <v-btn
                          depressed
                          tile
                          width="50%"
                          color="#CA0B19"
                          class="gen-button white--text"
                          @click="
                            orderTable = [];
                            isOrderDone = false;
                            searchQuery = '';
                          "
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          depressed
                          tile
                          width="50%"
                          :loading="finalOrderLoader"
                          color="#177D27"
                          class="gen-button white--text"
                          :disabled="invalidateAmountToPay"
                          @click="placeFinalOrder"
                        >
                          Place Order
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>

          <!-- Dialog -->

          <v-row justify="center" class="openDialogWrapper">
            <v-dialog
              v-model="openDialog"
              persistent
              fullscreen
              transition="scroll-x-reverse-transition"
              class="openDialog"
            >
              <v-card
                max-width="50%"
                tile
                class="ml-auto dialogCard"
                height="100%"
              >
                <!-- Select/Append Own Modifiers -->
                <div v-if="selectModifiersActive" class="formLayerCard">
                  <div
                    class="ownMenuBG"
                    :style="[
                      selectModifiersActive
                        ? {
                            backgroundImage:
                              'url(' + currentOwnOrder.image + ')',
                          }
                        : {
                            backgroundImage: 'url(' + noImage + ')',
                          },
                    ]"
                  ></div>
                  <v-form ref="dialogForm" class="dialog-form">
                    <v-row>
                      <v-col cols="12">
                        <h2>{{ currentOwnOrder.name }}</h2>
                        <div class="caption"><b>ADD OPTIONS</b></div>

                        <!-- Calculator -->
                        <div class="orderCalc selectModTable">
                          <table class="pa-4">
                            <colgroup>
                              <col span="1" style="width: 35%" />
                              <col span="1" style="width: 15%" />
                              <col span="1" style="width: 30%" />
                            </colgroup>

                            <tbody>
                              <tr
                                v-for="(mod,
                                index) in currentOwnOrder.resModifiers"
                                :key="index"
                                class="tr"
                              >
                                <td>
                                  <div class="d-flex">
                                    <v-checkbox
                                      v-model="currentOwnOrder.getSelectedTotal"
                                      @change="$forceUpdate()"
                                      :value="mod"
                                      class="text-center noSpaceCheckbox mr-1"
                                      hide-details
                                      color="primary"
                                    ></v-checkbox>
                                    <span class="mt-1">{{ mod.name }}</span>
                                  </div>
                                </td>
                                <td>
                                  <div
                                    class="d-flex justify-center align-center"
                                  >
                                    <v-btn
                                      depressed
                                      color="#5FA45F"
                                      class="white--text"
                                      x-small
                                      height="27px"
                                      :disabled="mod.unitPrice < 1"
                                      @click="decrementMod(index)"
                                    >
                                      <v-icon size="15">remove</v-icon>
                                    </v-btn>

                                    <span class="px-1">
                                      <b>{{ mod.quantity }}</b>
                                    </span>

                                    <v-btn
                                      depressed
                                      color="#5FA45F"
                                      class="white--text"
                                      x-small
                                      height="27px"
                                      :disabled="mod.unitPrice < 1"
                                      @click="incrementMod(index)"
                                    >
                                      <v-icon size="15">add</v-icon>
                                    </v-btn>
                                  </div>
                                </td>
                                <td>
                                  <b>{{ mod.sumPrice }}</b>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </v-col>
                    </v-row>
                  </v-form>

                  <div class="dialogAction text-right">
                    <v-btn
                      :ripple="false"
                      class="grey--text mr-3"
                      @click="openDialog = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      :ripple="false"
                      :loading="loader"
                      color="#E2001F"
                      class="gen-button white--text"
                      :disabled="
                        currentOwnOrder.getSelectedTotal &&
                        currentOwnOrder.getSelectedTotal.length < 1
                      "
                      @click="getOwnSelectedTotal"
                    >
                      <span>Add to Cart</span>
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </v-dialog>
          </v-row>
        </div>
      </div>
    </div>

    <!-- Snackbar Notification -->
    <v-snackbar
      class="snackbar"
      :color="snackBar.color"
      bottom
      right
      v-model="snackBar.active"
      :multi-line="snackBar.multiLine"
      :timeout="snackBar.timeout"
      >{{ snackBar.text }}</v-snackbar
    >
  </div>
</template>

<script>
import dashboard_Nav from "@/components/dashboard-nav";
import main_Nav from "@/components/mainNav";
// import bread_crumb from "@/components/breadcrumb";
import { mapState } from "vuex";
import axios from "axios";

export default {
  data() {
    return {
      title: "Order",
      isOrderDone: false,
      orderStage: "findCustomer", // default onLoad
      formDisabled: true,
      showResultPanel: false,
      loader: false,
      searchLoading: false,
      addCustomerLoader: false,
      finalOrderLoader: false,
      noImage:
        "https://upload.wikimedia.org/wikipedia/commons/9/90/No_image_available_600_x_400.svg",
      foundCustomer: null,
      customerResult: {},
      // customerResult: {
      //   id: "b775fd9a-8a16-404f-8ac3-ad3dbcd49119",
      //   enterpriseId: "88c8c539-c7e0-480e-9c87-384b86e70037",
      //   locationId: "06df667e-20d9-408c-9e03-49328f37264f",
      //   fullName: "Olanrewaju Olaboye",
      //   email: null,
      //   image: null,
      //   imageSecret: null,
      //   phone: "09087675454",
      //   buildingNumber: "20",
      //   streetName: "Ayodele",
      //   deliveryArea: "Bariga",
      //   nearestLandmark: "Palm Grove",
      //   deletedAt: null,
      //   isActivated: true,
      //   meta: {},
      //   createdAt: "2021-02-10T11:47:54.000Z",
      //   updatedAt: "2021-02-10T11:47:54.000Z",
      //   EnterpriseId: "88c8c539-c7e0-480e-9c87-384b86e70037",
      //   enterprise: {
      //     id: "88c8c539-c7e0-480e-9c87-384b86e70037",
      //     enterpriseName: "Sell A Boye",
      //     email: "sellaboye@gmail.com",
      //     isActive: true,
      //     deletedAt: null,
      //     createdAt: "2021-01-27T22:33:58.000Z",
      //     updatedAt: "2021-01-27T22:33:58.000Z",
      //   },
      // },
      editCustomerMode: false,
      custormerList: [],
      addCustomerData: {
        phone: "",
        fullName: "",
        locationId: "",
        buildingNumber: "",
        streetName: "",
        city: "",
        nearestLandmark: "",
        deliveryArea: "",
      },
      filterByBrand: "",
      filterDataByCat: "",
      menuDataReady: null,
      openDialog: false,
      selectModifiersActive: false,
      currentOwnOrder: {},
      paymentType: "",
      menuLocationByAdmin: "",
      orderTable: [],
      subTotal: 0,
      tax: [],
      surcharge: [],
      mustResetCoupon: false,
      couponCode: "",
      couponId: "",
      couponValue: "",
      couponResponse: "",
      discount: "",
      discountType: "",
      discountTypeOptions: [
        { name: "Coupon", value: "coupon" },
        { name: "Discount", value: "discount" },
      ],
      invalidateAmountToPay: false,
      ruleMsg: "",
      rules: {
        required: (value) => !!value || "Required",
        number: (value) => !value || /^[0-9]*$/.test(value) || "Invalid value",
        numberMax15: (value) =>
          !value ||
          (/^[0-9]*$/.test(value) && value.length < 16) ||
          "Must by phone digit (Max. 15)",
      },
      snackBar: {
        active: false,
        text: "",
        color: "",
        multiLine: "",
        timeout: this.$store.state.snackBarDuration,
      },
      searchQuery: "",
    };
  },
  methods: {
    resetAddCustomerData() {
      this.addCustomerData = {
        phone: "",
        fullName: "",
        locationId: "",
        buildingNumber: "",
        streetName: "",
        city: "",
        nearestLandmark: "",
        deliveryArea: "",
      };

      // reset validation
      this.$refs.customerForm.resetValidation();
    },
    nextStage(stage) {
      this.orderStage = stage;
    },
    appendMissingCustomer() {
      const getKeyword = this.searchQuery;
      if (parseInt(this.searchQuery)) {
        this.addCustomerData.phone = this.searchQuery;
        this.searchQuery = ""; // reset search input
      } else {
        setTimeout(() => {
          this.searchQuery = getKeyword; // restore previous entry
          // document.querySelector(".searchQuery").focus(); // not working
        }, 400);
        alert("invalid phone value");
      }
    },
    closeSearchModal() {
      // Event for when outside of modal is clicked
      setTimeout(() => {
        this.showResultPanel = false;
        // this.searchQuery = "";
      }, 500);
    },
    editCustomer() {
      if (this.$refs.customerForm.validate()) {
        this.addCustomerLoader = true;

        let data = JSON.parse(JSON.stringify(this.addCustomerData)); // deep cloning

        const wantedKeys = [
          "fullName",
          "nearestLandmark",
          "locationId",
          "phone",
          "deliveryArea",
          "buildingNumber",
          "streetName",
          "city",
        ];

        // Delete unecessary key fro edit
        // eslint-disable-next-line no-unused-vars
        for (const [key] of Object.entries(data)) {
          if (!wantedKeys.includes(key)) {
            delete data[`${key}`];
          }
        }

        axios
          .put("/api/v1/customer/" + this.addCustomerData.id, data, {
            headers: { Authorization: this.$store.state.token },
          })
          .then(() => {
            this.editCustomerMode = false; // IMPORTANT

            this.snackBar.active = true;
            this.snackBar.text = "Customer updated";
            this.snackBar.color = "success";

            this.addCustomerLoader = false;
          })
          .catch((error) => {
            this.addCustomerLoader = false;

            this.snackBar.active = true;
            this.snackBar.text =
              error.response.data.message || "Error updating customer";
            this.snackBar.color = "error";
            this.snackBar.timeout = this.$store.state.snackBarDuration;
          });
      }
    },
    addCustomer() {
      if (this.$refs.customerForm.validate()) {
        this.addCustomerLoader = true;
        axios
          .post("/api/v1/customer/", this.addCustomerData, {
            headers: { Authorization: this.$store.state.token },
          })
          .then((response) => {
            // Newly created customer data
            this.customerResult = response.data.data;

            this.addCustomerLoader = false;

            // change screen title
            this.title = "Showing menu for All Brands";

            // Reset add customer form
            this.$refs.customerForm.reset();

            // Proceed to next stage
            this.nextStage("foundCustomer");
          })
          .catch((error) => {
            this.addCustomerLoader = false;

            this.snackBar.active = true;
            this.snackBar.text =
              error.response.data.message || "Error adding customer";
            this.snackBar.color = "error";
            this.snackBar.timeout = this.$store.state.snackBarDuration;
          });
      }
    },
    addToOrderTable(menu) {
      if (this.orderTable.includes(menu)) {
        alert("Oops! That's a duplicate");
      } else {
        menu.quantity = 1;
        menu.resModifiers = [];

        // Restructure deep nested modifieritems
        // combine and bring out the deep modifierItems
        // to the first later i.e menu.resModifiers
        for (const key in menu) {
          if (key == "menuvariations") {
            menu[key].map((item) => {
              // store selection state as false
              item.selected = false;
            });
          }
          if (key == "meta") {
            // inside menu.meta
            // confirm that modifiers exists inside menu.meta
            if (menu[key].modifiers) {
              menu[key].modifiers.map((item) => {
                // if menu.meta.modifiers is not empty
                if (item.modifierItem.length > 0) {
                  item.modifierItem.map((modItem) => {
                    // store selection state as false
                    modItem.selected = false;
                    modItem.quantity = 1;
                    modItem.sumPrice = modItem.quantity * modItem.price;
                    // push all found modifierItem(modItem) inside this scope
                    // to the initial created arr outside this loops
                    // all pushes will make a conbined array of all modifierItem
                    // found in this menu
                    menu.resModifiers.push(modItem);
                  });
                }
              });
            }
          }
        }

        // Set init price for menu with 1 variation
        if (menu.menuvariations.length == 1) {
          menu.onlyDefault = true;
          menu.unitPrice = menu.menuvariations[0].price;
        } else {
          menu.unitPrice = 0;
        }
        this.orderTable.push(menu);
        // this.restructureModifierItem(); // restructure modifiers
      }
    },
    incrementOrder(index) {
      const reducer = (accumulator, currentValue) => accumulator + currentValue;
      let quantity = this.orderTable[index].quantity;

      let selectedMenuVar = [];
      if (this.orderTable[index].menuvariations.length > 1) {
        selectedMenuVar = this.orderTable[index].menuvariations.filter(
          (item) => item.selected == true
        );
      } else {
        selectedMenuVar.push(this.orderTable[index].menuvariations[0]);
      }

      let selectedMod = this.orderTable[index].getSelectedTotal;
      if (selectedMod && selectedMod.length > 0) {
        const num = selectedMod.map((menu) => parseInt(menu.sumPrice));
        selectedMod = num.reduce(reducer, 0);
      } else {
        // reset to empty arr
        selectedMod = [];
      }

      let origUnitPrice = selectedMenuVar[0].price;

      quantity++;
      let newPrice = quantity * origUnitPrice + selectedMod;

      // Set new price
      this.orderTable[index].unitPrice = newPrice;

      // Set new quantity
      this.orderTable[index].quantity = quantity;

      this.$forceUpdate();
    },
    decrementOrder(index) {
      let quantity = this.orderTable[index].quantity;
      const reducer = (accumulator, currentValue) => accumulator + currentValue;

      if (quantity == 1) {
        // break out of function when qty is 1 or <
        return (this.orderTable[index].quantity = 1);
      }
      let selectedMenuVar = [];
      if (this.orderTable[index].menuvariations.length > 1) {
        selectedMenuVar = this.orderTable[index].menuvariations.filter(
          (item) => item.selected == true
        );
      } else {
        selectedMenuVar.push(this.orderTable[index].menuvariations[0]);
      }

      let selectedMod = this.orderTable[index].getSelectedTotal;
      if (selectedMod && selectedMod.length > 0) {
        const num = selectedMod.map((menu) => parseInt(menu.sumPrice));
        selectedMod = num.reduce(reducer, 0);
      } else {
        // reset to empty arr
        selectedMod = [];
      }

      // let origUnitPrice;
      let origUnitPrice = selectedMenuVar[0].price;

      let newPrice = 0;

      if (quantity > 0) {
        quantity--;

        newPrice = quantity * origUnitPrice + selectedMod;

        // Set new price
        this.orderTable[index].unitPrice = newPrice;

        // Set new quantity
        this.orderTable[index].quantity = quantity;
      }
      this.$forceUpdate();
    },
    removeOrder(index) {
      // delete prev. appended data
      delete this.orderTable[index].getSelectedTotal;
      delete this.orderTable[index].index;

      this.orderTable.splice(index, 1);
    },
    calcSubTotal() {
      const reducer = (accumulator, currentValue) => accumulator + currentValue;

      let num = this.orderTable.map((menu) => parseInt(menu.unitPrice));
      let subTotal = num.reduce(reducer, 0);

      this.subTotal = subTotal;
    },
    updateUnitPriceVar(event, index) {
      // method to detect and grab selected price

      let currentPrice = this.orderTable[index].unitPrice;
      let prevAddition = this.orderTable[index].menuvariations.filter(
        (item) => item.selected == true
      );

      if (prevAddition.length > 0) {
        prevAddition = prevAddition[0].price;
      } else {
        prevAddition = undefined;
      }

      let getMenuvariations = [];

      if (event.selected == false) {
        if (prevAddition == undefined) {
          currentPrice += parseInt(event.price);

          this.orderTable[index].menuvariations.map((item) => {
            if (item.id === event.id) {
              item.selected = true;
            }
            getMenuvariations.push(item);
          });
        } else if (prevAddition >= 0) {
          currentPrice -= prevAddition;
          currentPrice += event.price;

          this.orderTable[index].menuvariations.map((item) => {
            if (item.id === event.id) {
              item.selected = true;
            } else {
              item.selected = false;
            }
            getMenuvariations.push(item);
          });
        }
      }

      this.orderTable[index].menuvariations = getMenuvariations;

      this.orderTable[index].unitPrice = currentPrice;
      this.$forceUpdate();
    },
    updateUnitPriceMod(event, index) {
      let currentPrice = this.orderTable[index].unitPrice;
      let prevAddition = this.orderTable[index].resModifiers.filter(
        (item) => item.selected == true
      );

      if (prevAddition.length > 0) {
        prevAddition = prevAddition[0].price;
      } else {
        prevAddition = undefined;
      }

      let getResModifiers = [];

      if (event.selected == false) {
        if (prevAddition == undefined) {
          currentPrice += parseInt(event.price);

          this.orderTable[index].resModifiers.map((item) => {
            if (item.id === event.id) {
              item.selected = true;
            }
            getResModifiers.push(item);
          });
        } else if (prevAddition >= 0) {
          currentPrice -= prevAddition;
          currentPrice += event.price;

          this.orderTable[index].resModifiers.map((item) => {
            if (item.id === event.id) {
              item.selected = true;
            } else {
              item.selected = false;
            }
            getResModifiers.push(item);
          });
        }
      }

      this.orderTable[index].resModifiers = getResModifiers;

      this.orderTable[index].unitPrice = currentPrice;
      this.$forceUpdate();
    },
    selectOwnModifier(order, index) {
      this.openDialog = true;
      this.selectModifiersActive = true;
      this.currentOwnOrder = JSON.parse(JSON.stringify(order)); // deep cloning

      // set getSelectedTotal for currentOwnOrder
      this.currentOwnOrder.getSelectedTotal = [];
      this.currentOwnOrder.index = index;
    },
    decrementMod(index) {
      let quantity = this.currentOwnOrder.resModifiers[index].quantity;

      // break out of function when qty is 1 or <
      if (quantity == 1) {
        return (this.currentOwnOrder.resModifiers[index].quantity = 1);
      }

      // =============

      let modPrice = this.currentOwnOrder.resModifiers[index].price;
      let newPrice = 0;

      if (quantity > 0) {
        quantity--;

        newPrice = quantity * modPrice;

        // Set new price
        this.currentOwnOrder.resModifiers[index].sumPrice = newPrice;

        // Set new quantity
        this.currentOwnOrder.resModifiers[index].quantity = quantity;
      }
      this.$forceUpdate();
    },
    incrementMod(index) {
      let quantity = this.currentOwnOrder.resModifiers[index].quantity;
      let modPrice = this.currentOwnOrder.resModifiers[index].price;
      let newPrice = 0;

      quantity++;

      newPrice = quantity * modPrice;

      // Set new price
      this.currentOwnOrder.resModifiers[index].sumPrice = newPrice;

      // Set new quantity
      this.currentOwnOrder.resModifiers[index].quantity = quantity;

      this.$forceUpdate();
    },
    getOwnSelectedTotal() {
      const index = this.currentOwnOrder.index;
      const total = this.currentOwnOrder.getSelectedTotal;
      this.orderTable[index].getSelectedTotal = total;

      this.openDialog = false;

      const reducer = (accumulator, currentValue) => accumulator + currentValue;
      const num = total.map((menu) => parseInt(menu.sumPrice));
      const newTotal = num.reduce(reducer, 0);

      this.orderTable[index].unitPrice += parseInt(newTotal);
    },
    resetSelectedMod(index) {
      const getModTotal = this.orderTable[index].getSelectedTotal;
      const reducer = (accumulator, currentValue) => accumulator + currentValue;

      const num = getModTotal.map((menu) => parseInt(menu.sumPrice));
      const modTotal = num.reduce(reducer, 0);

      // Update unit price of the order
      this.orderTable[index].unitPrice -= modTotal;

      // Delete the calc modifier array
      delete this.orderTable[index].getSelectedTotal;

      this.$forceUpdate();
    },
    resetCoupon() {
      this.discount = {};
      this.couponCode = "";
      this.couponValue = "";
      this.couponResponse = "";
      this.ruleMsg = "";
      this.mustResetCoupon = false;
    },
    verifyCoupon() {
      axios
        .post(
          "/api/v1/coupon/code/validate/",
          { code: this.couponCode, customerId: this.customerResult.id },
          {
            headers: { Authorization: this.$store.state.token },
          }
        )
        .then((response) => {
          try {
            let data = response.data.data;

            this.discount = data.orderdiscount;
            this.couponId = data.id;

            this.couponValue = data.orderdiscount.rate;
            this.couponResponse =
              "Coupon is valid with a value of: " + this.couponValue;
          } catch (error) {
            // throw New Error
          }
        })
        .catch((error) => {
          this.couponResponse =
            error.response.message || error.response.data.message;

          // const msg = error.response.message;
          // if (error.response.status == 400) {
          //   this.couponResponse = msg;
          // } else if (error.response.status == 404) {
          //   this.couponResponse = msg;
          // } else {
          //   this.couponResponse = error.response.data.message;
          // }
        });
    },
    collateOrderData() {
      // const reducer = (accumulator, currentValue) => accumulator + currentValue;
      // let order = this.orderTable;
      // eslint-disable-next-line no-unused-vars
    },
    placeFinalOrder() {
      // if (this.$refs.placeFinalOrder.validate()) {

      // Must select location for enterprise admin
      if (this.paymentType.length < 1) {
        return;
      }

      // Must select Payment Type
      if (this.userType > 8 && this.resOrderTable.locationId.length < 5) {
        // return alert("Please choose a location for this order");
      }

      this.finalOrderLoader = true;
      const data = this.resOrderTable;

      axios
        .post("/api/v1/order/", data, {
          headers: { Authorization: this.$store.state.token },
        })
        .then(() => {
          try {
            this.$router.push("/orders");
            this.finalOrderLoader = false;
          } catch (error) {
            return error;
          }
        })
        .catch((error) => {
          this.finalOrderLoader = false;

          this.snackBar.active = true;
          this.snackBar.text =
            error.response.data.message || "Error placing order";
          this.snackBar.color = "error";
          this.snackBar.timeout = this.$store.state.snackBarDuration;
        });
    },
  },
  watch: {
    calcAmountToPay(val) {
      if (val < 0) {
        this.mustResetCoupon = true;
        this.ruleMsg =
          "You can not owe the customer. Amount to pay must be at least 1";
        this.invalidateAmountToPay = true;
      } else if (val > 0) {
        // reset rulemsg and total amount validation
        this.ruleMsg = "";
        this.invalidateAmountToPay = false;
      }
      this.resOrderTable; //test
      this.$forceUpdate();
    },
    showResultPanel(val) {
      if (val == false) {
        // close modal if the search bar changes to empty
        // this.customerResult = {};
        this.foundCustomer = null;
      }
    },
    searchQuery(val) {
      if (val.length < 1) {
        this.foundCustomer = null;
        this.showResultPanel = false;
      } else {
        this.showResultPanel = true;
      }
    },
    filteredSearchResult(val) {
      if (val.length > 0 && this.searchQuery.length > 0) {
        // Means there is a result
        this.showResultPanel = true;
        this.foundCustomer = true;
      } else if (val.length < 1 && this.searchQuery.length > 0) {
        // Means there is No result
        this.showResultPanel = true;
        this.foundCustomer = false;
      }
    },
    openDialog(val) {
      if (val == false) {
        this.currentOwnOrder = {};
      }
    },
  },
  created() {
    this.$store.dispatch("getAllCategories");
    this.$store.dispatch("getAllTaxes");
    this.$store.dispatch("getAllSurcharges");
    this.$store.dispatch("getAllCoupons");
    this.$store.dispatch("getAllDiscounts");

    this.$store.dispatch("getAllMenu").then((response) => {
      if (response.status == 200 || response.status == 201) {
        this.menuDataReady = true;
      } else {
        this.menuDataReady = false;
      }
    });

    if (this.orderStage == "findCustomer") {
      this.$store.dispatch("getAllCustomers");
    }
  },
  computed: {
    resOrderTable() {
      let newOrder = this.orderTable;
      let data = {};
      data.orderitems = [];

      for (let i = 0; i < newOrder.length; i++) {
        // const element = array[i];

        const menuVariations = newOrder[i].menuvariations;
        menuVariations.forEach((element) => {
          let varData = {};
          if (element.selected == true) {
            varData.menuVariationId = element.id;
            varData.price = element.price;
            varData.brandId = newOrder[i].brandId;
            varData.quantity = newOrder[i].quantity;
            varData.subtotal = newOrder[i].unitPrice;

            data.orderitems.push(varData);
          }

          if (newOrder[i].getSelectedTotal) {
            if (newOrder[i].getSelectedTotal.length > 0) {
              const getSelectedTotal = newOrder[i].getSelectedTotal;
              varData.ordermodifiers = [];
              // let ordermodifiers = [];

              getSelectedTotal.forEach((mod) => {
                let getMod = {};

                getMod.modifierId = mod.id;
                getMod.price = mod.price;
                getMod.quantity = mod.quantity;
                getMod.subtotal = mod.sumPrice;

                varData.ordermodifiers.push(getMod);
              });
            }
          }
        });
      }

      // Register other datas
      data.price = this.calcAmountToPay;
      data.customerId = this.customerResult.id;
      data.locationId = this.userlocationId || this.menuLocationByAdmin;
      data.paymentType = this.paymentType;
      // data.orderDiscountId = this.discount.id;
      data.paymentMethod = "cash";

      // Set coupon
      if (this.discountType.length > 0) {
        data.discountType = this.discountType;

        if (this.discountType == "coupon" && this.couponId.length > 1) {
          data.couponId = this.couponId;
        } else if (
          this.discountType == "discount" &&
          this.discount.id.length > 1
        ) {
          data.orderDiscountId = this.discount.id;
        }
      }

      // Strip Arr
      if (this.tax.length > 1) {
        const tax = this.tax.map((tax) => tax.id);
        data.taxes = tax;
      }

      // Strip Arr
      if (this.surcharge.length > 1) {
        const surcharge = this.surcharge.map((surcharge) => surcharge.id);
        data.surcharges = surcharge;
      }

      return data;
    },
    calcDiscountedValue() {
      let discount = this.discount;

      let finalCalc = 0;

      if (discount) {
        if (discount.discountType == 1) {
          finalCalc = (discount.rate / 100) * this.subTotal;
        } else if (discount.discountType == 2) {
          finalCalc = discount.rate;
        }
      }
      return finalCalc;
    },
    calcTax() {
      try {
        const reducer = (accumulator, currentValue) =>
          accumulator + currentValue;

        let allTax = this.tax.map((menu) => parseInt(menu.rate));
        let sumAllTax = allTax.reduce(reducer, 0);

        sumAllTax = (sumAllTax / 100) * this.subTotal;

        return sumAllTax;
      } catch (error) {
        return error.message;
      }
    },
    calcSurcharge() {
      try {
        const reducer = (accumulator, currentValue) =>
          accumulator + currentValue;

        let allTax = this.surcharge.map((menu) => parseInt(menu.rate));
        const sumAllSurcharge = allTax.reduce(reducer, 0);

        return sumAllSurcharge;
      } catch (error) {
        return error.message;
      }
    },
    // Search for customers
    filteredSearchResult() {
      let grabArr = this.allCustomers;

      return grabArr.filter((item) => {
        if (
          item.phone.toLowerCase().indexOf(this.searchQuery.toLowerCase()) !==
          -1 // search by phone
        ) {
          return item;
        }
      });
    },
    // Search for order menu screen
    orderFilteredSearchResult() {
      try {
        let grabArr = this.allMenu;

        // Filter by category
        const filterDataByCat = this.filterDataByCat;
        if (filterDataByCat) {
          // grabArr = grabArr.filter((menu) => menu.categories.id == filterDataBy);
          grabArr = grabArr.filter((menu) => {
            if (menu.categories.length < 1) {
              menu.categories[0] = {};
              menu.categories[0]["id"] = "";
            }
            return menu.categories[0].id == filterDataByCat;
          });
        }

        return grabArr.filter((item) => {
          if (
            item.name.toLowerCase().indexOf(this.searchQuery.toLowerCase()) !==
            -1 // search by name
          ) {
            return item;
          }
        });
      } catch (error) {
        return [];
      }
    },
    ...mapState([
      "mainNav",
      "categories",
      "allCustomers",
      "enterpriseLocations",
      "entepriseBrands",
      "enterpriseCurrency",
      "allMenu",
      "allTaxes",
      "allSurcharges",
      "allCoupons",
      "allDiscounts",
      "userlocationId",
      "userType",
    ]),
    calcAmountToPay() {
      return (
        this.subTotal -
        this.calcDiscountedValue +
        this.calcSurcharge +
        this.calcTax
      );
    },
  },
  updated() {
    // Run each time there is any dom update
    this.calcSubTotal();
    // this.$forceUpdate();
  },
  components: {
    "dashboard-nav": dashboard_Nav,
    "main-nav": main_Nav,
    // breadcrumb: bread_crumb,
  },
  mounted() {},
};
</script>

<style scoped>
.searchCustomerResult {
  padding: 20px;
  color: #898989;
}
.orderMenuCat .v-tab--active .v-btn {
  /* background: #468346; */
  color: #ffffff;
}
.orderMenuCat >>> .v-tabs-slider-wrapper {
  display: none !important;
}

.orderMenuCatTab {
  border-radius: 5px !important;
}

.menubyBrands {
  background-color: #e0e0e0;
  border: 1px solid #d1d1d1;
  border-radius: 5px;
  padding: 10px 20px;
  height: 110px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  cursor: pointer;
}
.processOrder {
  background-color: #fafafa;
}
.processOrder .brandImage {
  height: 40px;
  width: 100px;
  border: 1px solid #d1d1d1;
  background-position: center;
  background-size: contain;
}
.processOrder .customer-info-wrapper {
  background-color: #eeeeee;
}

.orderCalc table {
  width: 100%;
}

.orderCalc table td {
  text-align: center;
  padding: 20px 0;
}

.orderCalc.selectModTable table td {
  padding: 5px 0;
}

.orderCalc table th {
  padding: 10px 0;
}
.orderCalc table tbody td:first-child {
  text-align: left;
  padding-left: 18px;
}
.orderCalc tr.tr {
  border-bottom: 1px solid #d5d5d5;
}
.orderCalc.selectModTable tr.tr {
  border-bottom: 0;
}

.resultPanelWrapper {
  position: absolute;
  width: inherit;
  max-width: 98%;
  min-height: 150px;
  outline: none;
  /* padding: 0 12px 12px 12px; */
}

.resultPanel {
  background-color: #ffffff;
  width: inherit;
  min-height: 150px;
  padding: 12px;
  border-top: 0;
}

.addCustomer-icon {
  cursor: pointer;
}

.editCustomerBtn {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}

.eachResult {
  cursor: pointer;
}

.menubyBrands-wrapper {
  padding: 0 6px;
}

.ownMenuBG {
  position: relative;
  height: 300px;
  width: 100%;
  background-position: center;
  background-size: cover;
}
.ownMenuBG::after {
  content: "";
  display: block;
  background: rgba(0, 0, 0, 0.3);
  position: absolute;
  width: 100%;
  height: 100%;
}
</style>
